/* TKBEncode */
export const TKBENCODE = "TKBENCODE"
export const TKBENCODE_SUCCESS = "TKBENCODE_SUCCESS"
export const TKBENCODE_FAIL = "TKBENCODE_FAIL"

export const TKBDECODE = "TKBDECODE"
export const TKBDECODE_SUCCESS = "TKBDECODE_SUCCESS"
export const TKBDECODE_FAIL = "TKBDECODE_FAIL"